import React, { useState, useEffect } from 'react';

const stats = [
  { num: '12,400+', label: 'Students enrolled' },
  { num: '3', label: 'Languages taught' },
  { num: '96%', label: 'Satisfaction rate' },
  { num: '38', label: 'Expert trainers' },
];

export default function About() {
  const [screen, setScreen] = useState('desktop');

  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      if (w < 640) setScreen('mobile');
      else if (w < 1024) setScreen('tablet');
      else setScreen('desktop');
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section
      id="about"
      style={{
        padding: screen === 'mobile' ? '3rem 1rem' : '5rem 2rem',
        background: 'var(--bg2)',
      }}
    >
      <div
        style={{
          maxWidth: '1120px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns:
            screen === 'mobile' ? '1fr' : '1fr 1fr', // ✅ responsive
          gap: screen === 'mobile' ? '2rem' : '4rem',
          alignItems: 'center',
        }}
      >
        {/* LEFT */}
        <div>
          <div
            style={{
              fontSize: '11px',
              fontWeight: '700',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              color: '#0ff4c6',
              marginBottom: '10px',
            }}
          >
            About us
          </div>

          <h2
            style={{
              fontSize: 'clamp(24px, 5vw, 42px)',
              fontWeight: '800',
              marginBottom: '1rem',
              lineHeight: 1.2,
              color: '#f0f4ff',
            }}
          >
            We help people speak
            <br />
            <span style={{ color: '#0ff4c6' }}>with confidence</span>
          </h2>

          <p
            style={{
              fontSize: '14px',
              color: '#94a3c4',
              lineHeight: 1.7,
              marginBottom: '1rem',
            }}
          >
            RSCourses was founded with one belief: everyone deserves to be heard.
            Our team of 38 expert trainers brings together phonetics science,
            real-world conversation practice, and cultural immersion.
          </p>

          <p
            style={{
              fontSize: '14px',
              color: '#94a3c4',
              lineHeight: 1.7,
            }}
          >
            Whether you are preparing for an interview, planning to travel, or
            simply want to communicate more clearly — we have a pathway designed
            for you.
          </p>
        </div>

        {/* RIGHT - STATS */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns:
              screen === 'mobile'
                ? '1fr'
                : screen === 'tablet'
                ? '1fr 1fr'
                : '1fr 1fr',
            gap: '14px',
          }}
        >
          {stats.map((s, i) => (
            <div
              key={i}
              style={{
                background: 'var(--surface)',
                border: '1px solid rgba(99,179,237,0.10)',
                borderRadius: '20px',
                padding: screen === 'mobile' ? '1.2rem' : '1.75rem',
                textAlign: 'center',
                transition: 'all 0.2s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor =
                  'rgba(15,244,198,0.3)';
                e.currentTarget.style.transform = 'translateY(-3px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor =
                  'rgba(99,179,237,0.10)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div
                style={{
                  fontSize: screen === 'mobile' ? '28px' : '36px',
                  fontWeight: '800',
                  color: '#0ff4c6',
                }}
              >
                {s.num}
              </div>

              <div
                style={{
                  fontSize: '12px',
                  color: '#4a5878',
                  marginTop: '6px',
                }}
              >
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}